import React, { useState } from "react";
import "./Sidebar.css";

const Sidebar = ({ onFilterCategory, onFilterPrice }) => {
  const [price, setPrice] = useState(10); // Estado para el precio seleccionado

  const handlePriceChange = (value) => {
    setPrice(value); // Actualizar el estado del precio
    onFilterPrice(value); // Llamar a la función de filtro con el nuevo valor
  };

  return (
    <aside className="sidebar">
      <h3>Filtrar</h3>
      <div className="filter-section">
        <h4>Precio</h4>
        <div className="price-filter">
          <input
            type="range"
            min="10"
            max="60"
            value={price}
            onChange={(e) => handlePriceChange(e.target.value)}
          />
          <span>${price}</span>
        </div>
      </div>
      <div className="filter-section">
        <h4>Categorías</h4>
        <ul>
          <li>
            <button onClick={() => onFilterCategory("")}>Todos los productos</button>
          </li>
          <li>
            <button onClick={() => onFilterCategory("Merchandising")}>
              Merchandising
            </button>
          </li>
          <li>
            <button onClick={() => onFilterCategory("Snow")}>Snow</button>
          </li>
          <li>
            <button onClick={() => onFilterCategory("Hogar")}>Hogar</button>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
